module.exports = __webpack_public_path__ + "img/IMG_6640-Edit.f7e055d4.jpg";